export enum VendorType {
    LABIS = 'LABIS',
    SCHILLER = 'SCHILLER',
    MCIP = 'MCIP',
}
